import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';
import { PlanMatchCandidate } from '@models/map/dxfTypes';

/**
 * Opération custom `POST /imports/{id}/plan/match-preview` : **sur quel champ reconnaître un
 * POI déjà présent** (`docs/PLAN_PARCOURS_IMPORT.md` §5).
 *
 * Sans cet écran, `matchFieldMapping` retombe sur `label` — qui porte le nom de l'exposant et
 * non le numéro de stand — et chaque réimport d'un hall RECRÉE les POI en doublon au lieu de
 * les mettre à jour, sans rien signaler.
 *
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { categoryPlaceTypeMapping } })`.
 * Le mapping des calques doit déjà être enregistré (c'est lui qui désigne les numéros) ; les
 * types de POI, eux, se passent dans le corps pour pouvoir comparer AVANT de valider.
 */
@doc.path('/imports/{id}/plan/match-preview')
export default class PlanMatchPreviewModel extends MapServiceModel {
	@doc.json   declare candidates: PlanMatchCandidate[];
	@doc.number declare numbers: number;
}
